import { type Session } from '@halo/chat-sdk-react';
import { MsgMediaCard, MsgMediaCardContent } from '../msg-media-card';
import type { MsgMediaCallContentProps } from './msg-media-call-content';

export interface MsgMediaCallProps extends MsgMediaCallContentProps {
  session: Session;
}

export const MsgMediaCall = memo(function MsgMediaCall({ message, session }: MsgMediaCallProps) {
  const { t } = useTranslation();

  return (
    <MsgMediaCard message={message} session={session}>
      <MsgMediaCardContent
        message={message}
        session={session}
        title={t('chat.onACall')}
        description={t('chat.onACall')}
      ></MsgMediaCardContent>
    </MsgMediaCard>
  );
});
